import {
  observable,
  action
} from 'mobx';
import base from '../../tool/base';
import {
  toJS
} from 'mobx';
import {
  message
} from 'antd';
import {
  InitStore
} from "../init/InitStore";
import util from '../../util/index';

const {
  catchApiError,
  getAccessToken,
} = util;
export class ListStore {
  @observable appDatas = [];
  @observable appDatas2 = [];
  @observable sreenDatas = [];
  @observable addModal = {
    addWhere: "0",
    visible: false,
    title: "",
    datas: [], //存放添加项目数据，项目数据或方案数据
    cloumns: []
  }
  @observable applyModal = {
    visible: false,
    title: "申请表单"
  }
  @observable routes = [];
  @observable pagination = {
    current: 1,
    pageSize: 10,
    total: 0,
  };
  @observable paginationAddModal = {
    currentAddModal: 1,
    pageSizeAddModal: 6,
    total: 0,
  };
  @observable rowSelection = {
    selectedRowKeys: [],
    selectedRows: [],
  };
  @observable rowSelectionAddModal = {
    selectedRowsKey: [],
    selectedRows: [],
  };
  @observable sreenDatasForAppAddModal = [];
  @observable orderBy = '0';
  @observable orderByAppAddModal = '0';
  @observable tabSelectedKey = 'basicInfo';
  @observable searchValue = {
    application: '',
    category: '0',
  };
  @observable searchValueInfo = "";
  @observable params = {
    searchValue: '',
    module: '',
    ind: '',
    type: 1,
    current: 1,
    apptype: '',
    count: 0,
    offset: 0,
    pageSize: 10,
    topN: 0,
    collect: '',
    access_token: 'bd863f38 - e328 - 4832 - b300 - 0da4087b5790',
    function: '',
    trade: '',
    wfstyle: 0,
    cloudStore: 1,
  };
  @observable loading = false;
  @observable count = 0;
  @observable selected = false; //List页面Table全选
  @observable sortDefaultIndex = 0;
  @observable sort = [
    [{
      key: '1',
      name: '类型',
      defaultValue: 'workflow',
      data: [{
          "key": "workflow",
          "name": "业务"
        },
        {
          "key": "style",
          "name": "样式"
        }
      ]
    }],
    [{
      key: '1',
      name: '',
      defaultValue: '',
      data: []
    }]
  ];
  @observable showStyle = false; //false:table排列；true:图标排列
  @observable appSelected = ''; //图标排列：选中的app的id值
  @observable func_radios = [];
  @observable func_radios_len = 1;
  @observable selectedApps = [];
  @observable loadingList = true;
  @observable showMore = true;

  constructor(routing) {
    this.routing = routing;
    this.setPage = this.setPage.bind(this);
    this.setPageModal = this.setPageModal.bind(this);
    this.getRoutes = this.getRoutes.bind(this);
    this.setShowStyle = this.setShowStyle.bind(this);
    this.setAppDatas2 = this.setAppDatas2.bind(this);
    this.setSelectedApps = this.setSelectedApps.bind(this);
    this.setSelectedAllApps = this.setSelectedAllApps.bind(this);
    this.setAppDatas = this.setAppDatas.bind(this);
    this.callAppData2 = this.callAppData2.bind(this);
    this.callAppData = this.callAppData.bind(this);
    this.setSreenDatas = this.setSreenDatas.bind(this);
    this.setSearchValue = this.setSearchValue.bind(this);
    this.setCurrent = this.setCurrent.bind(this);
    this.callScreenData = this.callScreenData.bind(this);
  }

  @action
  setMobxState = (params = {}) => {
    Object.keys(params).forEach(v => {
      this[v] = params[v];
    });
  }
  @action
  setCurrent(current) {
    this.params.current = current;
  }
  @action
  setSearchValue(value) {
    this.params.searchValue = value;
  }

  @action
  callAppData(id, params = {}) {
    params = {
      ...this.params,
      ...params,
      access_token: getAccessToken()
    };
    params.kind = id === "all" ?
      -1 :
      id === "workflow" ?
      1 :
      id === "portal" ?
      2 : -1;
    params.offset = (params.current - 1) * params.pageSize;
    this.loading = true;
    base.callApi('/v3/app', 'POST', params, 'json', 'text').then(data => catchApiError(data, this.routing)).then((data => {
      this.appDatas = params.current === 1 ? data.apps : this.appDatas.concat(data.apps);
      this.showMore = data.showMore;
      this.loading = false;
    }));
  }
  getResult(data, showMore, params) {
    //---------------------获取行业职能名称信息------------------------------
    let functionName = '',
      tradeName = '',
      functionId = '',
      tradeId = '';
    this.sreenDatas.forEach(item => {
      toJS(item).data.forEach(o => {
        o.data.forEach(v => {
          if (v.key === params.trade) {
            tradeName = v.name;
            tradeId = v.key;
          }
          v.funcList.forEach(l => {
            if (l.key === params.function) {
              functionName = l.name;
              functionId = l.key;
            }
          })
        })
      })
    })
    data.apps.forEach(item => {
      item.selected = false;
    })

    //----------------------防止重复增加相同的数据----------------------------------------
    let result = {
      function: functionId,
      functionName: functionName,
      trade: tradeId,
      tradeName: tradeName,
      data: data.apps
    };
    let pin = false; //防止增加重复的值
    this.appDatas2.forEach(item => {
      if (item.trade === result.trade && item.function === result.function) {
        pin = true;
      }
    })
    if (!pin) {
      this.appDatas2.push(result);
      this.func_radios_len = this.func_radios_len + 1;
    }
    //-------------------------------------------------------------------------------------
    if (showMore) this.showMore = this.func_radios_len !== this.func_radios[0].data.length;
    else this.showMore = showMore;
    this.loadingList = false;
  }

  callAppData2(id, params = {}, showMore) {
    params = {
      ...this.params,
      ...params,
      access_token: getAccessToken()
    };
    params.kind = id == "all" ?
      -1 :
      id == "workflow" ?
      1 :
      id == "portal" ?
      2 : -1;
    this.loadingList = true;
    this.loading = true;
    delete(params.offset);
    delete(params.pageSize);
    base.callApi('/v3/app', 'POST', params, 'json', 'text').then(data => catchApiError(data, this.routing)).then((data => {
      this.getResult(data, showMore, params);
      this.loading = false;
    }));
  }

  callScreenData(id, params) {
    base.callApi('/v3/genre?cloudStore=1', 'GET', {}, 'json', 'text').then((data) => {
      let tempSreenDatas = data.data;
      tempSreenDatas.forEach(temp => {
        temp.data.forEach(v => {
          if (v.key === params.radioType && params.radioItem) {
            v.defaultValue = params.radioItem;
          } else {
            v.defaultValue = '0';
          }
          let func_radioSum = [],
            allFunc = v.data[0];
          v.data.forEach(item => {
            func_radioSum = func_radioSum.concat(item.funcList.slice(1));
            if (item.g_id === params.radioItem) {
              this.func_radios = [{
                key: '1',
                name: '职能',
                defaultValue: params.radioSubItem || '0',
                data: item.funcList,
              }]
            }
          });
          if (!params.radioItem) {
            func_radioSum.unshift(allFunc);
            this.func_radios = [{
              key: '1',
              name: '职能',
              defaultValue: '0',
              data: func_radioSum,
            }]
          }
          if (this.showStyle) {
            this.appDatas2 = [];
            this.func_radios_len = 1;
            if (this.params.wfstyle === 0) {
              if (params.radioItem && params.radioSubItem) {
                this.callAppData2(id, params);
              } else {
                this.func_radios[0] && this.func_radios[0].data.forEach((item, index) => {
                  if (index > 0 && index <= 3) {
                    this.params.function = item.g_id;
                    this.params.trade = item.g_tradeid;
                    this.callAppData2(id, this.params, true);
                  }
                })
              }
            } else {
              this.callAppData2(id, params);
            }
          }
        });
      });
      this.sreenDatas = tempSreenDatas;
    });
  }

  callScreenDataForAppAddModal(params) {
    this.sreenDatasForAppAddModal = require("../../mocks/screen_" + params.id + ".json");
  }

  callAddWhereData(params, filter) {
    let where = "all";
    this.addModal = {
      ...this.addModal,
      addWhere: "1",
      title: "项目"
    };
    if (params === "2") {
      this.addModal = {
        ...this.addModal,
        addWhere: "2",
        title: "项目",
        cloumns: [{
          title: '项目名称',
          dataIndex: 'name',
        }, {
          title: '项目类别',
          dataIndex: 'type',
        }]
      }
      where = "proj";
    } else if (params === "3") {
      this.addModal = {
        ...this.addModal,
        addWhere: "3",
        title: "方案",
        cloumns: [{
          title: '方案名称',
          dataIndex: 'name',
        }]
      }
      where = "scheme";
    }
    setTimeout(() => {
      this.addModal = {
        ...this.addModal,
        datas: require("../../mocks/datas_where_" + where + ".json")
      };
      if (filter && filter !== '') {
        let temp = [];
        this.addModal.datas.filter(function (el) {
          if (el && el.name.indexOf(filter) >= 0) {
            temp.push(el);
          }
        });
        this.addModal = {
          ...this.addModal,
          datas: temp
        };
      }
      this.addModal = {
        ...this.addModal,
        visible: true
      };
      this.pageSizeAddModal = this.addModal.datas.length < this.pageSizeAddModal ? this.addModal.datas.length : this.pageSizeAddModal;
    }, 300);
  }

  callToAddAPP(app, where) {
    //??todo:添加应用到相应选择
    console.log("----callToAddAPP", app, where);
  }

  setPage(current, pageSize) {
    this.pagination = {
      ...this.pagination,
      current: current,
      pageSize: pageSize
    };
  }

  setPageModal(current, pageSize) {
    this.paginationAddModal = {
      ...this.pagination,
      currentAddModal: current,
      pageSizeAddModal: pageSize
    };
  }

  getRoutes(params) {
    this.routes = [{
      key: '1',
      breadcrumbName: '云商店',
      path: '/'
    }];
    if (params.id && params.id === 'all') {
      this.routes.push({
        key: '2',
        breadcrumbName: '全部应用',
        path: '/app/list'
      });
    } else if (params.id && params.id === 'workflow') {
      this.routes.push({
        key: '2',
        breadcrumbName: '流程表单',
        path: '/app'
      });
      this.routes.push({
        key: '3',
        breadcrumbName: '详情',
        path: '/',
      })
    } else if (params.id && params.id === 'portal') {
      this.routes.push({
        key: '2',
        breadcrumbName: '门户应用',
        path: '/app/list'
      });
    }
  }

  setSreenDatas(v) {
    this.sreenDatas = v;
  }

  //预览应用
  previewApp(v) {
    v && v.sw_id ?
      base.callApi('/v3/app/' + v.sw_id + '/preview?cloudStore=1', 'POST', {}, 'json', 'text').then((data) => {
        // console.log("data:",data);
      }) :
      "";
  }

  setShowStyle(showStyle) {
    this.showStyle = showStyle;
  }

  setAppDatas(appDatas) {
    this.appDatas = appDatas;
    this.params.current = appDatas.length + 1;
  }

  setAppDatas2(appDatas2) {
    this.appDatas2 = appDatas2;
  }

  setSelectedAllApps(app, checked) {
    if (checked) {
      let bool = true;
      this.selectedApps.forEach((item, index) => {
        if (item.trade === app.trade && item.function === app.function) {
          bool = false;
          this.selectedApps[index].data = app.data;
        }
      })
      if (bool) {
        this.selectedApps.push({
          trade: app.trade,
          function: app.function,
          data: app.data,
        });
      }
    } else {
      this.selectedApps.forEach((item, index) => {
        if (item.trade === app.trade && item.function === app.function) {
          this.selectedApps[index].data = [];
        }
      })
    }
    //更新store中的数据，做受控
    let temp = this.appDatas2;
    temp.forEach((o, index) => {
      if (o.trade === app.trade && o.function === app.function) {
        toJS(o.data).forEach((l, m) => {
          temp[index].data[m].selected = checked;
        })
      }
    })
    this.appDatas2 = temp;
  }

  setSelectedApps(app, v, checked) {
    //存储当前选中的值,用于按钮操作（批量申请与收藏）
    if (checked) {
      let bool = true;
      this.selectedApps.forEach((item, index) => {
        if (item.trade === app.trade && item.function === app.function) {
          bool = false;
          this.selectedApps[index].data = this.selectedApps[index].data.concat(v);
        }
      })
      if (bool) {
        this.selectedApps.push({
          trade: app.trade,
          function: app.function,
          data: [v]
        });
      }
    } else {
      this.selectedApps.forEach((item, index) => {
        if (item.trade === app.trade && item.function === app.function) {
          item.data.forEach((o, m) => {
            if (o.key === v.key) {
              this.selectedApps[index].data.splice(m, 1);
            }
          })
        }
      })
    }
    //更新store中的数据，做受控
    let temp = this.appDatas2;
    temp.forEach((o, index) => {
      if (o.trade === app.trade && o.function === app.function) {
        toJS(o.data).forEach((l, m) => {
          if (l.key === v.key) {
            temp[index].data[m].selected = checked;
          }
        })
      }
    })
    this.appDatas2 = temp;
  }
  renderAppDatas(param = {}) {
    const ids = param.s_ids.split(',');
    ids.forEach(v => {
      this.appDatas.forEach((o, index) => {
        if (o.sw_id === v) {
          if (o.tms_iscoll === '1') this.appDatas[index].tms_iscoll = '0';
          else this.appDatas[index].tms_iscoll = '1';
        }
      })
    });
  }
  callCollect(param, type) {
    let collect = type === 'collect' ? 0 : 1;
    let params = {
      collect: collect,
      access_token: getAccessToken(),
      cloudStore: 1,
      ...param,
    };
    base.callApi('/v3/appcollect/edit4batch', 'POST', params, 'json', 'text').then(data => catchApiError(data, this.routing)).then((data) => {
      if (data.status === 'true') {
        message.success(type === 'collect' ? "收藏成功" : '取消成功');
        this.renderAppDatas(param);
      } else {
        message.success(data.msg ? data.msg : type === 'collect' ? '收藏失败，请重试！' : '取消失败，请重试！');
        localStorage.removeItem('me');
        InitStore.me = {};
      }
    });
  }
}


//-------------------------table 分页全选样式代码-----------------------
// callAppData
// this.count = data.count;
// this.pagination = {...this.pagination, total: this.appDatas.length};

//
// let intersection = this.rowSelection.selectedRows.filter(v => {
//   let temp = data.apps.filter(o => {
//     return o.sw_id === v.sw_id;
//   });
//   return temp.length !== 0;
// });
// this.selected = intersection.length === data.apps.length;
//----------------------------------------------------------------------

// //判断请求的数据是否存在 : 用于滚屏加载（onscroll)
// callAppData2
// let result = {
//   function: functionId,
//   functionName: functionName,
//   trade: tradeId,
//   tradeName: tradeName,
//   data: data.apps
// };
// let pin = false;//防止增加重复的值
// this.appDatas2.forEach(item => {
//   if (item.trade === result.trade && item.function === result.function) {
//     pin = true;
//   }
// })
// if (!pin) {
//   this.appDatas2.push(result);
//   this.func_radios_len = this.func_radios_len + 1;
// }
// -------------------------------------------------------


// WEBPACK FOOTER //
// ./src/stores/list/ListStore.js